import Vue, { CreateElement, RenderContext, VNode } from "vue";
import { formatMoney } from "@/lib/helpers/money";

interface Props {
  currencyCode: string;
  withSymbol: boolean;
  withSign: boolean;
  tag: string;
}

export default Vue.extend({
  functional: true,
  name: "FormatMoney",
  render(h: CreateElement, ctx: RenderContext<Props>): VNode {
    const defaultSlot = ctx.scopedSlots.default && ctx.scopedSlots.default({});
    const text = defaultSlot && defaultSlot[0].text;
    const { tag, ...options } = ctx.props;
    const formattedAmount = text ? formatMoney(text, options) : "";
    return h(tag || "span", ctx.data, formattedAmount);
  }
});
